exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.attributes-table{height:75vh;font-size:9pt}.attributes-table .attributes-table-style-actions{min-width:120px}.attributes-table .attributes-table-style-actions .actions-icons{text-align:center;white-space:nowrap}.attributes-table .attributes-table-style-phone{min-width:105px}.attributes-table .attributes-table-style-th-datetime{min-width:110px}.attributes-table .attributes-table-style-td-datetime{text-align:center}", ""]);

// exports
